export default "__VITE_ASSET__DjouppwL__";